import React from 'react';

const Home = () => {
  return (
    <div id="home" className="jumbotron jumbotron-fluid">
      <div id="home-text" className="container">
        <h1>Mark De May</h1>
        <h2>Web Developer</h2>
      </div>
    </div>
  )
}

export default Home;



// WEBPACK FOOTER //
// ./src/Components/Home.js